import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/work', label: 'Work' },
    { path: '/process', label: 'Process' },
    { path: '/about', label: 'About' },
    { path: '/explore-ideas', label: 'Explore Ideas' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-[#f5f2ed]/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1600px] mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex flex-col">
            <span className="text-2xl font-['Playfair_Display'] text-[#1a1a1a] tracking-tight">
              Hale Modular
            </span>
            <span className="text-xs text-[#9c9590] tracking-widest uppercase mt-0.5">
              Built to Last
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm tracking-wide transition-colors relative group ${
                  location.pathname === link.path ? 'text-[#1a1a1a]' : 'text-[#9c9590]'
                }`}
              >
                {link.label}
                <span className="absolute bottom-[-4px] left-0 w-0 h-[1px] bg-[#b8986e] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
          </nav>

          <Link
            to="/contact"
            className="hidden md:block bg-[#1a1a1a] text-[#f5f2ed] px-6 py-3 text-sm tracking-wide hover:bg-[#2a2a2a] transition-all duration-300 hover:-translate-y-0.5"
          >
            Inquire
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#1a1a1a] p-2"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-[#f5f2ed] md:hidden pt-20">
          <nav className="flex flex-col items-center gap-8 py-12">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xl font-['Playfair_Display'] transition-colors ${
                  location.pathname === link.path ? 'text-[#1a1a1a]' : 'text-[#9c9590]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="bg-[#1a1a1a] text-[#f5f2ed] px-8 py-4 text-base tracking-wide mt-4"
            >
              Inquire
            </Link>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;
